<template>
  <!-- 抽屉详情 -->
  <el-dialog
    v-dragDialog
    :title="drawerTitle"
    :visible.sync="drawerVisible"
    width="800px"
    :close-on-click-modal="false"
  >
    <el-form
      :model="dataForm"
      ref="dataForm"
      label-width="120px"
      :rules="formRules"
    >
      <shortOrderInfo ref="shortOrderInfo" :order="dataForm" />
      <el-form-item style="margin-top: 20px; text-align: right">
        <el-button type="success" @click="handleSubmit(true)"
          >确认接单</el-button
        >
        <el-button type="warning" @click="handleSubmit(false)"
          >拒绝订单</el-button
        >
        <el-button type="danger" @click="handelTimeOut()"
          >接单超时取消订单</el-button
        >
      </el-form-item>
    </el-form>
  </el-dialog>
</template>
  <script>
import { shopConfirmUserAppoint } from "@/api/bussiness/dzopen";
import memberSelector from "@/components/memberSelector.vue";
import enumSelector2 from "@/components/enumSelector2.vue";
import shortOrderInfo from "./shortOrderInfo.vue";
export default {
  components: {
    enumSelector2,
    memberSelector,
    shortOrderInfo,
  },
  data() {
    return {
      dataForm: {},
      formRules: {},
      drawerTitle: "",
      drawerVisible: false,
    };
  },
  methods: {
    show(row) {
      this.drawerTitle = "预约接单";
      this.drawerVisible = true;
      console.log(row);
      this.dataForm = row;
    },
    handelTimeOut()
    {
      let para = { key: this.dataForm.Key, accept: false,timeOut:true, };
      shopConfirmUserAppoint(para).then((response) => {
        if (response) {
          this.drawerVisible = false;
          this.msg.successMsg("操作完成！");
          this.$emit("update");
        }
      });
    },
    handleSubmit(accept) {
      let para = { key: this.dataForm.Key, accept: accept,timeOut:false };
      shopConfirmUserAppoint(para).then((response) => {
        if (response) {
          this.drawerVisible = false;
          this.msg.successMsg("操作完成！");
          this.$emit("update");
        }
      });
    },
  },
  mounted() {},
};
</script>
  <style lang='scss'  scoped>
/deep/.el-tabs--border-card > .el-tabs__content {
  padding: 0;
  height: 1px;
}

/deep/.el-form-item {
  margin-bottom: 10px;
}

.tab-content {
  margin-top: -2px;
  border: 1px solid #dcdfe6;
  border-top: 0;
  padding: 15px;
  background: #fff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
}

.row-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-self: center;
}

/deep/.el-drawer__header {
  margin-bottom: 15px;
  font-size: 18px;
  font-weight: bold;
  color: #ff862f;
}

/deep/.el-drawer__body {
  overflow-y: scroll;
}

/deep/.el-card__header {
  font-size: 16px;
}
</style>